import { Component } from '@angular/core';

import { ClassicEditor } from '@/common/editor/classic-editor';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-resident-base-trip',
	templateUrl: './resident-base-trip.component.html',
	styleUrls: ['./resident-base-trip.component.css'],
})
export class ResidentBaseTripComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 1;
	protected parentComponent = 'resident/residentBaseTrips';
	protected apiUrl = 'resident/residentBaseTrips/';
	protected apiUrlAdd = '/resident/residentBaseTrips/';
	locations: Array<any> = [];
	data = {
		destinations: null,
		name: null,
		priceEuro: null,
		priceHr: null,
		discountValue: null,
		discountAge: null,
		description: null,
		show: 0,
	};
	editor = ClassicEditor;
	editorConfig = {
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};

	protected loadBefore() {
		this.api.get('/bag/bagLocations/', (result) => {
			this.locations = result.data;
			this.loadData();
		});
	}

	protected convertData(data) {
		data.destinations = data.destinations.map((item) => item.bagLocations);
		return data;
	}
}
